import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import styled from 'styled-components';

const QRCodeDisplay = ({ btcAddress, inscriptionAddress, btcAmount, inscriptionAmount }) => {
  return (
    <QRCodeContainer>
      <Title>付款信息</Title>
      <Description>
        请向以下两个地址分别转账，完成后系统将自动处理您的空投请求
      </Description>
      
      <QRCodeWrapper>
        <QRCodeBox>
          <QRCodeTitle>BTC 接收地址</QRCodeTitle>
          <QRCodeTitle>需支付 {btcAmount} 个BTC</QRCodeTitle>
          <QRCodeStyled 
            value={btcAddress}
            size={180}
            bgColor="#ffffff"
            fgColor="#000000"
            level="H"
            includeMargin={false}
          />
          <AddressText>{btcAddress}</AddressText>
          <CopyButton onClick={() => copyToClipboard(btcAddress)}>
            复制地址
          </CopyButton>
        </QRCodeBox>
        
        <QRCodeBox>
          <QRCodeTitle>铭文接收地址</QRCodeTitle>
          <QRCodeTitle>需转移 {inscriptionAmount} 个铭文</QRCodeTitle>
          <QRCodeStyled 
            value={inscriptionAddress}
            size={180}
            bgColor="#ffffff"
            fgColor="#000000"
            level="H"
            includeMargin={false}
          />
          <AddressText>{inscriptionAddress}</AddressText>
          <CopyButton onClick={() => copyToClipboard(inscriptionAddress)}>
            复制地址
          </CopyButton>
        </QRCodeBox>
      </QRCodeWrapper>
      
      <Instructions>
        <InstructionTitle>付款说明：</InstructionTitle>
        <InstructionList>
          <InstructionItem>1. 向第一个地址转入 BTC 作为服务费, 服务费为: 随机地址每100个0.0015BTC, 指定地址每100个0.002BTC</InstructionItem>
          <InstructionItem>2. 向第二个地址转入需要空投的铭文。铭文数量为: 空投的地址数 x 每个地址空投的数量</InstructionItem>
          <InstructionItem>3. 两笔交易确认后，系统将自动处理您的空投请求</InstructionItem>
        </InstructionList>
      </Instructions>
      
      <ReturnButton onClick={() => window.location.reload()}>
        返回下单页面
      </ReturnButton>
    </QRCodeContainer>
  );
};

// 辅助函数 - 复制到剪贴板
const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text)
    .then(() => {
      alert('地址已复制到剪贴板');
    })
    .catch(err => {
      console.error('复制失败:', err);
    });
};

// 样式组件
const QRCodeContainer = styled.div`
  background-color: rgba(30, 30, 30, 0.6);
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: 15px;
  font-size: 24px;
  text-align: center;
`;

const Description = styled.p`
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 30px;
  text-align: center;
  font-size: 16px;
`;

const QRCodeWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 30px;
  margin-bottom: 30px;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    align-items: center;
  }
`;

const QRCodeBox = styled.div`
  background-color: rgba(40, 40, 40, 0.8);
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
  }
`;

const QRCodeTitle = styled.h3`
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 500;
`;

const QRCodeStyled = styled(QRCodeSVG)`
  margin-bottom: 15px;
  padding: 10px;
  background-color: white;
  border-radius: 8px;
`;

const AddressText = styled.div`
  background-color: ${({ theme }) => theme.colors.inputBg};
  color: ${({ theme }) => theme.colors.text};
  padding: 10px 15px;
  border-radius: 6px;
  font-size: 12px;
  width: 100%;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 10px;
  cursor: text;
  user-select: all;
`;

const CopyButton = styled.button`
  background-color: ${({ theme }) => theme.colors.buttonBg};
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 15px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #e78c19;
  }
`;

const Instructions = styled.div`
  background-color: rgba(40, 40, 40, 0.5);
  border-radius: 8px;
  padding: 15px 20px;
  margin-bottom: 25px;
`;

const InstructionTitle = styled.h4`
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 10px;
  font-size: 16px;
`;

const InstructionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const InstructionItem = styled.p`
  color: ${({ theme }) => theme.colors.text};
  font-size: 14px;
`;

const ReturnButton = styled.button`
  background-color: transparent;
  color: ${({ theme }) => theme.colors.secondary};
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  display: block;
  margin: 0 auto;
  
  &:hover {
    background-color: rgba(247, 147, 26, 0.1);
  }
`;

export default QRCodeDisplay;